import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { wizardFormKeys } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/hooks/queryKeys';
import { getWizardPaymentInfo } from 'services/product';

export const useGetWizardPaymentInfo = (params, options = {}) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: wizardFormKeys.payment(params?.wizardFormId),
    queryFn: () => getWizardPaymentInfo(params),
    enabled: !!params?.wizardFormId,
    ...options,
  });

  // Fetch payment info with a specific wizardFormId (for new forms)
  const fetchPaymentInfo = useCallback(
    async (wizardFormId) => {
      if (!wizardFormId) return null;

      return queryClient.fetchQuery({
        queryKey: wizardFormKeys.payment(wizardFormId),
        queryFn: () => getWizardPaymentInfo({ wizardFormId }),
        staleTime: 0,
      });
    },
    [queryClient]
  );

  return {
    ...query,
    fetchPaymentInfo,
  };
};
